import { api } from '../lib/api'
import type { ActionSharedState, ActionState, ActionStatus, Priority } from '../lib/types'

export interface ActionLogInput {
  status: ActionStatus
  note?: string | null
  reason?: string | null // motivo em 1 clique (só "Não fiz"/"Fiz diferente")
  reviewAt?: string | null // YYYY-MM-DD — obrigatório quando status='review'
}

export interface OpenAction extends ActionSharedState {
  id: string
  description: string
  priority: Priority
  type: 'optimization' | 'derived'
  // Só vem quando type==='derived': origem da ação derivada.
  investigationType?: 'ai_auto' | 'manager_manual'
  reportId: string
  weekStart: string
  clientId: string
  clientName: string
  managerId: string
  managerName: string
}

export interface OpenActionsFilters {
  status?: ActionStatus | 'all' // default 'pending' no backend; 'all' = todos
  week?: string // YYYY-MM-DD — semana Seg–Dom do RELATÓRIO (por weekEnd)
  reviewWeek?: string // YYYY-MM-DD — semana Seg–Dom da data de REVER (reviewAt)
  clientId?: string // filtra por um cliente específico (vazio = todos)
}

export const actionsApi = {
  logOptimization: (actionId: string, body: ActionLogInput) =>
    api.put<{ state: ActionState }>(`/actions/optimization/${actionId}/log`, body),
  logDerived: (actionId: string, body: ActionLogInput) =>
    api.put<{ state: ActionState }>(`/actions/derived/${actionId}/log`, body),
  open: (filters: OpenActionsFilters = {}) => {
    const p = new URLSearchParams()
    if (filters.status) p.set('status', filters.status)
    if (filters.week) p.set('week', filters.week)
    if (filters.reviewWeek) p.set('reviewWeek', filters.reviewWeek)
    if (filters.clientId) p.set('clientId', filters.clientId)
    const qs = p.toString()
    return api.get<{ actions: OpenAction[] }>(`/actions/open${qs ? `?${qs}` : ''}`)
  },
}
